import { render } from "./CertificationSection.vue?vue&type=template&id=a539d852&ts=true"
import script from "./CertificationSection.vue?vue&type=script&lang=ts"
export * from "./CertificationSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__